import { Component, OnInit } from '@angular/core';
import { ParameterService } from 'src/app/shared/service/params/param';
import { ApexOptions } from 'ng-apexcharts';
import { MessageService } from 'primeng/api';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import * as FileSaver from 'file-saver';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-graphique',
  templateUrl: './graphique.component.html',
  styleUrls: ['./graphique.component.scss'],
})
export class GraphiqueComponent implements OnInit {
  projets: any[] = [];
  selectedProjet: any;
  userInfo: any;
  date_fin: string;
  date_debut: string;
  isLoading: boolean = false;
  annee: boolean = false;
  totalFinancementEtat: number = 0;
  totalFinancementFondPropre: number = 0;
  totalGeneral: number = 0;
  // ApexCharts configuration
  simplePieChart: any;

  constructor(
    private messageService: MessageService,
    private parameterService: ParameterService,
    private ngxService: NgxUiLoaderService,
    private localstorage: LocalStorageService,


  ) {
    this.userInfo = this.localstorage.getInfoUserToService();
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();

    // Use exercise year instead of current year
    this.date_debut = `${this.annee}-01-01`;
    this.date_fin = `${this.annee}-12-31`;

  }

  ngOnInit(): void {
    this.getMontantByProjet();
    this.calculerTotaux()

  }
  getMontantByProjet() {
    const requestData = {
      date_debut: this.date_debut,
      date_fin: this.date_fin,
    };
    this.isLoading = true;

    this.parameterService.getMontantByProjet(requestData).subscribe(
      (response: any) => {
        this.isLoading = false;

        const projetsData = response.data;
        let total = 0;

        if (!projetsData || projetsData.length === 0) {
          this.simplePieChart = null;
          return;
        }
        projetsData.forEach((item: any) => {
          total += Number(item.total);
        });

        this.projets = projetsData
          .map((item: any) => {
            return {
              ...item,
              pourcentage: ((item.total / total) * 100).toFixed(1),
            };
          })
          .sort((a: any, b: any) => b.total - a.total);

        //console.log('this.projets', this.projets);

        if (this.projets.length > 0) {
          this.selectedProjet = this.projets[0];
          this.updateChart();
        }

        this.calculerTotaux();
      },
      (error) => {
        //console.log('une erreur est survenue', error);
      }
    );
  }

  calculerTotaux() {
  this.totalFinancementEtat = this.projets.reduce((sum, p) => sum + (+p.mt_financement_etat || 0), 0);
this.totalFinancementFondPropre = this.projets.reduce((sum, p) => sum + (+p.mt_financement_fond_propre || 0), 0);
this.totalGeneral = this.projets.reduce((sum, p) => sum + (+p.total || 0), 0);
  }
updateChart() {
  const totalMontants = this.projets.map((projet) =>
    Number(projet.total) || 0
  );

  const labels = this.projets.map((projet) =>
    projet.nom_programme || 'Sans nom'
  );

  const colors = ['#42A5F5', '#66BB6A', '#FFA726', '#FF7043', '#AB47BC'];

  // 🔒 sécurité : éviter chart vide
  if (totalMontants.length === 0 || totalMontants.every(v => v === 0)) {
    this.simplePieChart = null;
    return;
  }

  this.simplePieChart = {
    series: totalMontants,
    chart: {
      type: 'pie',
      width: 600,
    },
    labels: labels,
    legend: {
      position: 'top',
      horizontalAlign: 'center',
    },
    colors: colors.slice(0, this.projets.length),
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 300, // ⚠️ 900 était trop grand pour mobile
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };
}

  onRowSelect(event: any) {
    this.selectedProjet = event.data;
    this.updateChart();
  }

  isNaN(value: any): boolean {
    return isNaN(value);
  }
}
